import React from "react";
import { SxProps } from "@mui/material";
import { UISwitch } from "../BuildlingBlocks/UISwitch";
import { ObserveState } from "../StateManagement/ObserveState";
import { StateManager } from "../../rule-engine-core/Common/StateManager";
import { getPropertyEditorValidationIssues, PropertyEditorValidationTooltip } from "./PropertyEditorValidationTooltip";

export interface PropertyEditorBooleanInterface {
    editObject: object;
    propertyName: string;
    label?: string;
    color?: string | "secondary" | "default";
    name?: string;
    onChange?: () => void;
    sx?: SxProps;
    sxSwitch?: SxProps;
    hint?: string;
    error?: string;
    ignoreDesignerValidation?: boolean;
}

export const PropertyEditorBoolean: React.FC<PropertyEditorBooleanInterface> = (
    props: PropertyEditorBooleanInterface,
) => {
    const onChange = (val: boolean) => {
        Reflect.set(props.editObject, props.propertyName, val);
        StateManager.propertyChanged(props.editObject, props.propertyName);
        if (props.onChange) props.onChange();
    };

    return (
        <ObserveState
            listenTo={props.editObject}
            properties={[props.propertyName]}
            control={() => {
                let val = Reflect.get(props.editObject, props.propertyName);

                let validationIssues = getPropertyEditorValidationIssues(
                    props.editObject,
                    props.propertyName,
                    props.error,
                );

                return (
                    <PropertyEditorValidationTooltip
                        editObject={props.editObject}
                        propertyName={props.propertyName}
                        error={validationIssues}
                    >
                        <UISwitch
                            label={props.label}
                            hint={props.hint}
                            fullWidth={true}
                            sx={props.sxSwitch}
                            value={val || false}
                            error={validationIssues?.message}
                            onChange={onChange}
                        ></UISwitch>
                    </PropertyEditorValidationTooltip>
                );
            }}
        />
    );
};
